module.exports = __webpack_public_path__ + "static/media/web-form.7db4a3d6.svg";